<template>
  <div>
    <div v-if="dosePendente != null">
      Falta
      <i class="icofont-close-circled" style="color: red"></i>
    </div>
    <div v-else-if="dose != null">
      {{ formatDate(dose.dt_plc) }}
      <i
        :class="dose.dt_plc != null ? 'icofont-check-circled' : ''"
        :style="{
          color: dose.dt_plc != null ? 'green' : '',
        }"
      ></i>
      <!-- <br />
      com {{ dose.meses }} meses -->
      <span
        v-if="dose.dose_anterior == 1"
        v-b-tooltip.hover.right
        title="Dose registrada como transcrição de caderneta."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import utils from '@/mixins/utils'

export default {
  props: {
    item: {
      type: [Object, Boolean],
      default: false,
    },
    dose: {
      type: [Object, Boolean],
      default: false,
    },
    dosePendente: {
      type: [Object, Boolean],
      default: false,
    },
    meses: {
      type: Number,
      default: 0,
    },
  },
  mixins: [utils],
}
</script>

<style></style>
